import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import CreateUpdateContainer from '../../../components/CreateUpdateContainer/CreateUpdateContainer';
import useFields from './fields';
import useAuthContext from '../../../contexts/AuthContext';
import InfosModal from './InfosModal';

const CreateUpdateCompliance = ({ purpose }) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const [form] = Form.useForm();
  const fields = useFields(t, form, user?.insurer?._id);

  return (
    <>
      <InfosModal openInfosModal />
      <CreateUpdateContainer
        fields={fields}
        purpose={purpose}
        config={{}}
        baseUrl="insurers"
        resource="insurers"
        form={form}
      />
    </>
  );
};

CreateUpdateCompliance.propTypes = {
  purpose: PropTypes.string.isRequired
};

export default CreateUpdateCompliance;
